import './Home.css'

const Refund = () => {
    return (
        <div className="home">
            <div className="hero-background"></div>

            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1 className="animate-slideUp stagger-1">
                            Cancellation & <span className="text-gradient">Refund</span>
                        </h1>
                        <p className="hero-subtitle animate-slideUp stagger-2">
                            Last Updated: December 31, 2025
                        </p>
                    </div>
                </div>
            </section>

            <section className="features">
                <div className="container">
                    <div className="glass-card" style={{ padding: '3rem', marginBottom: '4rem', lineHeight: '1.8' }}>
                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem' }}>1. Order Cancellation</h2>
                        <div style={{ marginLeft: '1rem' }}>
                            <h3 style={{ fontSize: '1.2rem', color: 'white' }}>A. Physical Products (QR Tags)</h3>
                            <p>You may cancel your order for physical QR tags within 12 hours of placing it, as long as the item has not been dispatched. Once shipped, cancellations are no longer possible.</p>

                            <h3 style={{ fontSize: '1.2rem', color: 'white', marginTop: '1rem' }}>B. Digital Services (Subscriptions/Recharges)</h3>
                            <p>Digital recharges and utility payments are processed instantly and cannot be cancelled once the transaction is initiated.</p>
                        </div>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>2. Refund Policy</h2>
                        <div style={{ marginLeft: '1rem' }}>
                            <h3 style={{ fontSize: '1.2rem', color: 'white' }}>A. Eligibility</h3>
                            <p>Refunds are considered only in the following cases:
                                <ul>
                                    <li>Defective physical product received.</li>
                                    <li>Payment made but service not rendered (e.g., recharge failed but money deducted).</li>
                                    <li>Duplicate transaction due to system error.</li>
                                </ul>
                            </p>

                            <h3 style={{ fontSize: '1.2rem', color: 'white', marginTop: '1rem' }}>B. Non-Refundable Items</h3>
                            <p>
                                <ul>
                                    <li>Subscription fees for Franchise Management plans already in use.</li>
                                    <li>Successfully completed recharges and utility payments.</li>
                                    <li>Promotional or referral credits.</li>
                                </ul>
                            </p>
                        </div>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>3. Refund Process</h2>
                        <p>To request a refund, please contact our support team at support@nah44.com with your order ID and proof of issue. We will review your request within 3-5 business days. Approved refunds will be processed back to the original payment method within 7-14 business days.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>4. Shipping Policy for Returns</h2>
                        <p>If you receive a defective tag, we will bear the cost of shipping for the replacement. For other authorized returns, the customer is responsible for shipping costs.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>5. Franchise Refunds</h2>
                        <p>Franchise setup fees are generally non-refundable once the account has been activated and the digital menu has been configured. However, pro-rated refunds for monthly subscriptions may be considered on a case-by-case basis.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>6. Contact Us</h2>
                        <p>For any billing or refund queries, reach out to our accounts team at billing@nah44.com.</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Refund
